module.exports = __webpack_public_path__ + "static/emm-007-a3b86afeeb13d1433f75dfbc2b207da6.jpg";